// Detect whether the SPA is running inside the Shopify Admin embed.
// We treat any page where window.shopify (set by App Bridge) is present
// as embedded. Settled once at first render and exposed via React
// context so every page renders consistently for the lifetime of the
// session.

import { type ReactNode, createContext, useContext, useMemo } from 'react';

const EmbedContext = createContext<boolean>(false);

export function EmbedProvider({ children }: { children: ReactNode }): JSX.Element {
  const isEmbedded = useMemo(() => {
    if (typeof window === 'undefined') return false;
    return Boolean(window.shopify);
  }, []);
  return <EmbedContext.Provider value={isEmbedded}>{children}</EmbedContext.Provider>;
}

export function useIsEmbedded(): boolean {
  return useContext(EmbedContext);
}
